import React from 'react';
import "../founders/founders.css";
import InfoBox from "../../common/infobox/Infobox";
import data from "../../../configs/founders/founders.json";

const Founders = () => {
  return (
    <div className="founders" id="founders-section">
      <div className="founders-heading">Founders</div>
      <div className="infobox-list">
        {data.founders.map((founder, index) => {
          return (
            <InfoBox
              key={index}
              title={founder.title}
              designation={founder.designation}
              description={founder.description}
              link={founder.navigationLinks}
              height={window.innerWidth <= 600 ? "223.87px" : "240px"}
              width={window.innerWidth <= 600 ? "343.27px" : "368px"}
              image={
                window.innerWidth <= 600
                  ? founder.imageLink.mobile
                  : founder.imageLink.web
              }
              socialMedia={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Founders;
